import MarginBox from "../../shared/components/other/MarginBox";
import Navbar from "../../shared/components/navbar/NavBar";
import Footer from "../../shared/components/other/Footer";
import { classNames } from "../../shared/shared";
import PromoteButtons from "./components/PromoteButtons";
import styles from "./main.module.scss"; // Импорт SCSS-модуля
import Button from "../../shared/components/UI/Button";
import { useState } from "react";
import { displayNotImplemented } from "../../shared/services/Notifications/NotificationServices";

//В навбаре изменить скругления
// в Подробнее изменить подсветку при наводке (уточнить на совещаниии с зацепиным)
// Убрать обрезку со свечения картинки в css на главной
//Про

export default function Main() {
  return (
    <MarginBox>
      <Navbar />
      <main className={styles["main"]}>
        {/* Блок 1 */}
        <div className={styles["block-1"]}>
          <h1>
            Новая эра <br />
            страйкбола
          </h1>
          <p>Революционные устройства и экосистема в мире тактических игр</p>
          <PromoteButtons actionName="Купить" actionRef="" detailsRef=""  />
        </div>

        {/* Блок 2 */}
        <div className={styles["block-2"]}>
          <img className={styles['block-2_imgBackground']} src="/Main/Player.png" alt="Игрок" />
          <img className={styles['block-2_image']} src="/Main/Player.png" alt="Игрок" />
        </div>

        {/* Блок 3 */}
        <div className={styles["block-3"]}>
          <h2>Экосистема с афишей, приложением и умными устройствами</h2>
          <p>
            Зарегистрируйтесь в системе чтобы попробовать весь функционал
            экосистемы Киберштаб
          </p>
          <PromoteButtons
            className="block-3-promote"
            actionName="Зарегистрироваться"
            actionRef="/register"
            detailsRef=""
          />
        </div>

        {/* Блок 4 */}
        <div className={styles["block-4"]}>
          <div className={styles["block-4-1"]}>
            <div className={styles["b-4-1-h2-container"]}>
              <h2 className={styles["b-4-1-h2-1"]}>Инновации в деле</h2>
              <h2 className={styles["b-4-1-h2-2"]}>От игроков для игроков</h2>
            </div>
            <div
              className={classNames(
                styles["block-4-block"],
                styles["block-4-1-1"]
              )}
            >
              <p>
                Удобные <br />
                фильтры для <br />
                поиска игры
              </p>
              <img className="block-4-1-1-image" src="/Main/frameData.png" />
            </div>
            <p className={styles["block-4-2-p"]}>
              Новая афиша мероприятий страйкбольного комьюнити
            </p>
          </div>
          <div className={styles["block-4-2"]}>
            <div className={styles["b-4-1-h2-container"]}>
              <p className={styles["block-4-2-p-base"]}>
                Мы — это вы. Мы тоже любим страйкбол и решили улучшить игровой
                опыт каждого, от начинающих до самых закоренелых игроков. Пусть
                движение тактических игр в России достигнет новых высот.
              </p>
            </div>
            <div
              className={classNames(
                styles["block-4-block"],
                styles["block-4-2-1"]
              )}
            >
              <p>
                Множество <br />
                функций в одном <br />
                приложении
              </p>
              <img className="block-4-1-2-image" src="/Main/phone.png" />
            </div>
            <p className={styles["block-4-2-p"]}>
              Мобильное приложения-помощник организатора и командира
            </p>
          </div>
        </div>

        {/* Блок 5 */}
        <div className={styles["block-5"]}>
          <div className={styles["block-5-1"]}>
            <h2>Устройства Киберштаб</h2>
            <p className={styles["block-5-1-p"]}>
              Несколько режимов в одной коробке, подключение через собственный
              сервис,
              <br />
              отслеживание игровой информации онлайн
            </p>
            <PromoteButtons
              actionName="Хочу купить"
              actionRef=""
              detailsRef=""
            />
          </div>
        </div>

        {/* Блок 6 */}
        <div className={styles["block-6"]}>
          <h2>Устройство + Приложение</h2>
          <h3>Лучшее решение</h3>
          <div className={styles["block-6-2"]}>
            <div className={styles["block-6-2-background"]}>
              <h4 className={styles["block-6-2-h4"]}>Регистрация</h4>
              <img src="/Main/cybercard_base.png" alt="Карта" />
              <p className={styles["block-6-2-p"]}>
                Регистрируйте игроков через устройства и мобильное приложение
                Киберштаб
              </p>
            </div>
            <div className={styles["block-6-2-background"]}>
              <h4 className={styles["block-6-2-h4-unique"]}>Статистика</h4>
              <div className={styles["block-6-2-percents-background"]}>
                <div className={styles["block-6-2-percents"]}>
                  <div className={styles["block-6-2-percents-1-container"]}>
                    <p className={styles["block-6-2-percents-1"]}>61%</p>
                    <div className={styles["block-6-2-percents-1-arrows"]}>
                      <div
                        className={styles["block-6-2-percents-1-arrow-1"]}
                      ></div>
                      <div
                        className={styles["block-6-2-percents-1-arrow-2"]}
                      ></div>
                      <div
                        className={styles["block-6-2-percents-1-arrow-3"]}
                      ></div>
                    </div>
                  </div>
                  <p className={styles["block-6-2-percents-2"]}>
                    Процент побед
                  </p>
                </div>
              </div>
              <img
                className={styles["block-6-2-image"]}
                src="/Main/player2.png"
                alt="Подбор картинки"
              />
              <p className={styles["block-6-2-p"]}>
                Отслеживайте статистику игроков и устройств в режиме реального
                времени
              </p>
            </div>
            <div className={styles["block-6-2-background"]}>
              <h4 className={styles["block-6-2-h4"]}>Режим</h4>
              <img src="/Main/points.png" alt="Подбор картинки" />
              <p className={styles["block-6-2-p"]}>
                Несколько точек могут работать в связке, находясь в состоянии
                разных режимов
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </MarginBox>
  );
}
